import URI from 'urijs'

export default function getProductListFilterOptionsFromUrl(href) {
  const url = new URI(href)
  const query = url.search(true)
  return query
}
